import { generatePagerProps } from '@fukuri-admins/utils/common/generatePagerProps';
import { useClientContractList } from './hooks';
import { convertToPresentationProps } from './logics';
import { ClientContractListPresentation } from './presentations';
import { ClientContractListEmptyPresentation } from './presentations/empty';

/**
 * 企業契約期間一覧 Container
 *
 * サイドバー導線のため clientId は不要。
 */
export const ClientContractList: React.FC = () => {
  const {
    state: {
      data,
      clientNameValue,
      contractPlanNameValue,
      isFiltered,
      currentPage,
      totalPage,
      totalCount,
    },
    actions: {
      handleClientNameChange,
      handleContractPlanNameChange,
      handleSearch,
      handleClientNameClear,
      handleContractPlanNameClear,
      handlePageChange,
      handleRowClick,
    },
  } = useClientContractList();

  const { clientContracts, isEmpty } = convertToPresentationProps({ data, isFiltered });

  const pagerProps = generatePagerProps({
    currentPage,
    totalPage,
    totalCount,
    rows: clientContracts,
    onPageChange: handlePageChange,
  });

  return isEmpty ? (
    <ClientContractListEmptyPresentation />
  ) : (
    <ClientContractListPresentation
      clientContracts={clientContracts}
      clientNameValue={clientNameValue}
      contractPlanNameValue={contractPlanNameValue}
      onClientNameChange={handleClientNameChange}
      onContractPlanNameChange={handleContractPlanNameChange}
      onSearch={handleSearch}
      onClientNameClear={handleClientNameClear}
      onContractPlanNameClear={handleContractPlanNameClear}
      pagerProps={pagerProps}
      createLink='/client-contracts/new'
      onRowClick={handleRowClick}
    />
  );
};
